import { render, staticRenderFns } from "./case-related-procedure.vue?vue&type=template&id=3e1ab1ed&"
import script from "./case-related-procedure.vue?vue&type=script&lang=js&"
export * from "./case-related-procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports